import { Loader, QueryBoundary } from '@outdoria/ui';
import { Map } from './Map';

import s from './HomeView.module.scss';

export const HomeView = () => (
  <QueryBoundary fallback={<Loader fullScreen />}>
    <Load />
  </QueryBoundary>
);

const Load = () => {
  return (
    <div className={s.homeView}>
      <Map />
    </div>
  );
};
